<template>
    <div class="d-flex flex-fill">
        <sidebar v-if="!isAuth && !isDemo && !isAds"></sidebar>
        <router-view v-if="isDemo || isAds"></router-view>
        <div v-else class="main-content d-flex flex-fill p-4"
             :class="{'sidebar-margin' : !isAuth && !isDemo && !isAds}">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import Sidebar from '@/components/Sidebar'

    export default {
        name: 'app',
        components: {
            Sidebar
        },
        computed: {
            isAuth() {
                return this.$route.path.match('auth');
            },
            isDemo() {
                return this.$route.path.match('demo');
            },
            isAds() {
                return this.$route.path.match('ads');
            },
            isApp() {
                return !this.isAuth && !this.isDemo && !this.isAds
            }
        },
        created() {
            let self = this;
            adamApi.interceptors.request.use(
                (config) => {
                    let token = this.$cookie.get('api_token');
                    if (token) {
                        config.headers['Authorization'] = 'Bearer ' + token;
                    }
                    return config
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            adamApi.interceptors.response.use(
                function (response) {
                    return response;
                },
                function (error) {
                    if (error.response.status === 401) {
                        self.$cookie.delete('api_token');
                        self.$router.push('/auth/login');
                    }
                    console.log("An error ocurred -> " + error);
                    return Promise.reject(error);
                });
        }
    }
</script>

<style lang="scss">
    @import "./sass/app";
</style>
